import React, { useEffect, useState } from 'react';
import UIBody from '../../../components/ui/UIBody';
import { Link, Navigate } from 'react-router-dom';
import useApiCallHooks from '../../../hooks/useApiCallHooks';



const QuizePage = () => {
  
 const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
const[data,setData]=useState([]);


useEffect(()=>{
  callAPI('get','quizes');
},[]);

useEffect(() => {
  if (statusCode === 200 && responce?.data) {
    setData(responce.data);
  }
}, [statusCode, responce]);

  return (
    <UIBody
    loading={loading}
      content={
        <div className="bg-light">
           <section class="cta__area-four">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-xl-10">
<div
  className="cta__inner-wrap mt-4"
  style={{
    background: 'linear-gradient(90deg, rgba(131, 58, 180, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%)',
    borderRadius: '20px',
    // padding: '40px',
    color: '#fff' // ensures text is readable
  }}
>
 <div class="cta__img-three tg-svg " >
                      <img
                        src="https://html.themegenix.com/skillgro/assets/img/others/h8_cta_img.png"
                        alt="img"
                      />
                      <span
                        class="svg-icon"
                        id="cta-svg"
                        data-svg-icon="assets/img/others/h8_cta_img_shape.svg"
                      ></span>
                    </div>

  <div className="cta__content-three cta__content-four">
    <div className="content__left">
      <h2 className="title text-center"  >Find the Right Quiz for You</h2>
      <p>
        Challenge yourself and enhance your skills with interactive and fun
        quizzes tailored to your learning goals.
      </p>
    </div>
  </div>

  <img
    src="assets/img/others/h8_cta_shape.svg"
    alt="shape"
    className="shape"
  />
</div>


</div>

              </div>
            </div>
          </section>
          <section class="courses-area-four courses__bg-three py-1" data-background="assets/img/bg/h5_courses_bg.jpg">
            <div class="container">
              <div class="row justify-content-center">
               <div class="col-xl-8 col-lg-8">
  <div class="section__title text-center mb-50">
    <span class="sub-title">Top Class Quizzes</span>
    <h2 class="title bold">Get the Most Exciting Quiz Experience With Us</h2>
  </div>
</div>

              </div>
              <div className="row g-4">
                {data.map((quiz) => (
                  <div key={quiz.id} className="col-lg-4 col-md-6">
                    <div className="courses__item-six shine__animate-item">
                      <div className="courses__item-thumb-five shine__animate-link">
                        <a href=""><img src={quiz.image} alt="img" /></a>
                        <a href="" className="courses__wishlist-two">{quiz.plays}</a>
                      </div>
                      <div className="courses__item-content-five">
                        <ul className="courses__item-meta list-wrap">
                          <li className="courses__review courses__review-two">
                            <div className="rating">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                            </div>
                            <span>{quiz.rating}</span>
                          </li>
                        </ul>
                        <div className="d-flex gap-2 mb-3 flex-wrap">
                          <span className="badge bg-primary-subtle text-primary">{quiz.tag}</span>
                          <span className="badge bg-success-subtle text-success">{quiz.level}</span>
                        </div>
                        <div className='courses_item_quiz_title'>
                          <h2 className="title">
                            <Link to={`/quize/show/${quiz.slug}`}>
                              {quiz.name}
                            </Link>
                          </h2>
                        </div>
                        <div className='courses_item_quiz_title'>
                          <p>{quiz.description}</p>
                        </div>
                        <div className="courses__item-content-bottom-two">
                          <ul className="list-wrap">
                            <li>
                              <div className="icon"><i className="skillgro-happiness"></i></div>
                              <p><span>Age:</span>{quiz.age}</p>
                            </li>
                            <li>
                              <div className="icon"><i className="skillgro-time"></i></div>
                              <p><span>Question: </span>{quiz.questions}</p>
                            </li>
                          </ul>
                        </div>
                      <Link to={`/quize/show/${quiz.slug}`} className="btn btn-primary w-100 fw-bold quiz-button rounded mt-3">
  ▶ Start Quiz
</Link>

                      </div>
                    </div>
                  </div>
                ))}
              </div>


            </div>
            <div class="courses__shape-wrap-three">
              <img src="assets/img/courses/h5_courses_shape01.svg" alt="shape" data-aos="fade-right" data-aos-delay="400" />
              <img src="assets/img/courses/h5_courses_shape02.svg" alt="shape" data-aos="fade-up-right" data-aos-delay="400" />
              <img src="assets/img/courses/h5_courses_shape03.svg" alt="shape" class="alltuchtopdown" />
              <img src="assets/img/courses/h5_courses_shape04.svg" alt="shape" data-aos="fade-up-left" data-aos-delay="400" />
            </div>
          </section>
          {/* <section class="features__area-six py-2">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-xl-6 col-lg-8">
                  <div class="section__title text-center mb-40">
                    <h2 class="title bold">Grow and expand your skills through enjoyable & imaginative</h2>
                    <p>Modorem ipsum dolor sit amet, consectetur adipisicing elitsed eius modetempor incididunt ulabore et dolore magna aliqua.</p>
                  </div>
                </div>
              </div>
              <div class="features__item-wrap-three">
                <div class="row justify-content-center">
                  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                    <div class="features__item-five">
                      <div class="features__item-five-shape">
                        <div class="shape-one">
                          <img src="assets/img/others/h5_features_item_shape.svg" alt="" class="injectable" />
                        </div>
                        <div class="shape-two">
                          <img src="assets/img/others/h5_features_item_shape02.svg" alt="" class="injectable" />
                        </div>
                      </div>
                      <div class="features__icon-five">
                        <i class="skillgro-video-tutorial"></i>
                        <img src="assets/img/icons/h5_features_icon.svg" alt="" class="injectable" />
                      </div>
                      <div class="features__content-five">
                        <h2 class="title">Easy Class</h2>
                        <p>Dear psum dolor amettey adipis aecing eiusmod incididutt reore</p>
                        <a href="about-us.html" class="btn arrow-btn">Read More <img src="assets/img/icons/right_arrow.svg" alt="" class="injectable" /></a>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                    <div class="features__item-five">
                      <div class="features__item-five-shape">
                        <div class="shape-one">
                          <img src="assets/img/others/h5_features_item_shape.svg" alt="" class="injectable" />
                        </div>
                        <div class="shape-two">
                          <img src="assets/img/others/h5_features_item_shape02.svg" alt="" class="injectable" />
                        </div>
                      </div>
                      <div class="features__icon-five">
                        <i class="skillgro-verified"></i>
                        <img src="assets/img/icons/h5_features_icon.svg" alt="" class="injectable" />
                      </div>
                      <div class="features__content-five">
                        <h2 class="title">Safety & Security</h2>
                        <p>Dear psum dolor amettey adipis aecing eiusmod incididutt reore</p>
                        <a href="about-us.html" class="btn arrow-btn">Read More <img src="assets/img/icons/right_arrow.svg" alt="" class="injectable" /></a>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                    <div class="features__item-five">
                      <div class="features__item-five-shape">
                        <div class="shape-one">
                          <img src="assets/img/others/h5_features_item_shape.svg" alt="" class="injectable" />
                        </div>
                        <div class="shape-two">
                          <img src="assets/img/others/h5_features_item_shape02.svg" alt="" class="injectable" />
                        </div>
                      </div>
                      <div class="features__icon-five">
                        <i class="skillgro-instructor"></i>
                        <img src="assets/img/icons/h5_features_icon.svg" alt="" class="injectable" />
                      </div>
                      <div class="features__content-five">
                        <h2 class="title">Skilled Teacher</h2>
                        <p>Dear psum dolor amettey adipis aecing eiusmod incididutt reore</p>
                        <a href="about-us.html" class="btn arrow-btn">Read More <img src="assets/img/icons/right_arrow.svg" alt="" class="injectable" /></a>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                    <div class="features__item-five">
                      <div class="features__item-five-shape">
                        <div class="shape-one">
                          <img src="assets/img/others/h5_features_item_shape.svg" alt="" class="injectable" />
                        </div>
                        <div class="shape-two">
                          <img src="assets/img/others/h5_features_item_shape02.svg" alt="" class="injectable" />
                        </div>
                      </div>
                      <div class="features__icon-five">
                        <i class="skillgro-book-1"></i>
                        <img src="assets/img/icons/h5_features_icon.svg" alt="" class="injectable" />
                      </div>
                      <div class="features__content-five">
                        <h2 class="title">Clean Curriculum</h2>
                        <p>Dear psum dolor amettey adipis aecing eiusmod incididutt reore</p>
                        <a href="about-us.html" class="btn arrow-btn">Read More <img src="assets/img/icons/right_arrow.svg" alt="" class="injectable" /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="features__shape-wrap-two">
              <img src="assets/img/others/h5_features_shape01.svg" alt="shape" class="rotateme" />
              <img src="assets/img/others/h5_features_shape02.svg" alt="shape" data-aos="fade-down-left" data-aos-delay="400" />
            </div>
          </section> */}

          <section class="about-area-five section-pb-140">
            <div class="container">
              <div class="row align-items-center justify-content-center">
                <div class="col-lg-6 col-md-8">
                  <div class="about__images-five">
                    <div class="about__mask-img-one">
                      <img src="https://img.freepik.com/free-photo/girl-student-hand-hug-book_1150-4131.jpg" alt="img" />
                    </div>
                    <div class="about__mask-img-two" data-aos="fade-right" data-aos-delay="200">
                      <img src="https://media.istockphoto.com/id/1768516789/photo/child-thinking-and-homework-with-light-bulb-for-learning-math-numbers-and-creative-ideas-or.jpg?s=1024x1024&w=is&k=20&c=s3GYnWSczeKNlT9iBBqrGjZflkZ4qb9K04PlUlMIYQc=" alt="img" />
                    </div>
                    <div class="shape">
                      <img src="assets/img/others/h5_about_img_shape01.svg" alt="shape" data-aos="fade-down-left" data-aos-delay="400" />
                      <img src="assets/img/others/h5_about_img_shape02.svg" alt="shape" data-aos="fade-up-right" data-aos-delay="400" />
                      <img src="assets/img/others/h5_about_img_shape03.svg" alt="shape" class="rotateme" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="about__content-five">
                    <div class="section__title mb-15">
                      <span class="sub-title">Get More About Us</span>
                      <h2 class="title bold">Our passion is childhood, and we’re in kindergarten</h2>
                    </div>
                    <p>Groove’s intuitive shared inbox makes it easy for team members to organize, prioritize and.In this episode of the Smashing Pod we’re talking about Web Platform Baseline.</p>
                    <ul class="about__info-list list-wrap">
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">Quality School Schedule</p>
                      </li>
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">Indoor/Outdoor Games for Little Kids</p>
                      </li>
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">Supporting the Child’s Personality</p>
                      </li>
                    </ul>
                    <div class="about__content-bottom">
                      <Link to="/contactus" class="btn arrow-btn">Start Free Trial <img src="assets/img/icons/right_arrow.svg" alt="" class="injectable" /></Link>
                      <div class="about__contact">
                        <div class="icon">
                          <i class="skillgro-phone-call"></i>
                          <svg width="61" height="57" viewBox="0 0 61 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.8271 1.03084C45.4231 1.45238 55.2747 9.02544 58.7825 19.8885C62.2129 30.5119 58.2066 41.852 49.1968 48.6277C39.3708 56.0171 26.0908 58.9731 15.8124 52.2032C4.34981 44.6532 -2.0548 30.6516 2.45508 17.8409C6.75857 5.61644 20.666 0.552417 33.8271 1.03084Z" stroke="currentcolor" stroke-width="2" />
                          </svg>
                        </div>
                        <div class="content">
                          <a href="tel:0123456789">+91-9834143101</a>
                          <span>Call to Questions</span>
                        </div>
                      </div>
                    </div>
                    <div class="shape">
                      <img src="assets/img/others/h5_about_shape02.png" alt="shape" class="alltuchtopdown" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="about__shape">
              <img src="assets/img/others/h5_about_shape01.png" alt="shape" data-aos="fade-right" data-aos-delay="800" />
            </div>
          </section>



          <section class="faq__area-two tg-motion-effects section-py-140">
            <div class="container">
              <div class="row align-items-center justify-content-center">
                <div class="col-lg-6 col-md-8 order-0 order-lg-2">
                  <div class="faq__img-three">
                    <div class="faq__mask-img">
                      <img src="https://img.freepik.com/free-photo/joyful-schoolboy-with-heavy-backpack_1098-3469.jpg" alt="img" />
                    </div>
                    <div class="faq__img-shape">
                      <img src="assets/img/others/h5_faq_img_shape.svg" alt="" class="injectable" />
                    </div>
                    <div class="shape shape-one" data-aos="fade-down-left" data-aos-delay="400">
                      <img src="assets/img/others/h5_faq_shape02.svg" alt="shape" class="tg-motion-effects3" />
                    </div>
                    <div class="shape shape-two" data-aos="fade-up-left" data-aos-delay="400">
                      <img src="assets/img/others/h5_faq_shape03.svg" alt="shape" class="tg-motion-effects4" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="faq__content-two">
                    <div class="section__title mb-15">
                      <span class="sub-title">Faq’s</span>
                      <h2 class="title bold">Why Our Schools are the Right Fit for Your Child?</h2>
                    </div>
                    <p>Groove’s intuitive shared inbox makes it easy for team members to organize, prioritize and.In this episod.</p>
                    <div class="faq__wrap faq__wrap-two">
                      <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Well Trained Professionals
                            </button>
                          </h2>
                          <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                              <p>Sorem ipsum dolor sit amet consectur adipiscing elit sed eius mod
                                nt labore dolore magna aliquaenim ad minim sorem ipsum dolor sit
                                amet consectur adipiscing elit sed eius modam.</p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              Flexible Class Plans
                            </button>
                          </h2>
                          <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                              <p>Sorem ipsum dolor sit amet consectur adipiscing elit sed eius mod
                                nt labore dolore magna aliquaenim ad minim sorem ipsum dolor sit
                                amet consectur adipiscing elit sed eius modam.</p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              Learn From Anywhere
                            </button>
                          </h2>
                          <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                              <p>Sorem ipsum dolor sit amet consectur adipiscing elit sed eius mod
                                nt labore dolore magna aliquaenim ad minim sorem ipsum dolor sit
                                amet consectur adipiscing elit sed eius modam.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="faq__shape">
              <img src="assets/img/others/h5_faq_shape01.svg" alt="shape" class="tg-motion-effects3" />
            </div>
          </section>


          
          
        </div>
      }
    />
  );
};

export default QuizePage;
